import { useQuery } from "@tanstack/react-query";
import { api } from "@/APIRequests";
import type { UUID } from "@/core/types";

export const PATIENT_CONSENTS_QUERY_KEYS = {
  default: ["patientConsents"] as const,
  list: (patientId: UUID) => [...PATIENT_CONSENTS_QUERY_KEYS.default, patientId] as const,
};

/** We want to explicitly opt-out from the default loading spinner to show skeletons and do optimistic updates */
const params = {
  showLoader: false,
};

export function usePatientConsents(patientId: UUID) {
  return useQuery({
    queryKey: PATIENT_CONSENTS_QUERY_KEYS.list(patientId),
    queryFn: () => api.providerTyped.get_patient_consents({ patientId, params }),
    enabled: !!patientId,
    refetchOnWindowFocus: true,
  });
}
